import React, { useState } from 'react';
import styled from 'styled-components';
import { colors, misc, breakpoints } from '../../styles/utilities/settings';

const ToggleBar = ({ children }) => {
  const [viewOpen, setViewOpen] = useState(false);
  return (
    <SToggleBar>
      <div onClick={() => {
      setViewOpen(!viewOpen);
    }} className={`toggle${viewOpen ? ' open' : ''}`}>{`${viewOpen ? 'Close' : 'View'} Contributing Factors`}<span /><span /></div>
    { viewOpen &&
      <div className="columns">
      { children }
      </div>
}
    </SToggleBar>
  )
}

export default ToggleBar;

const SToggleBar = styled.div`
  margin-top: 30px;

  @media screen and (max-width: ${breakpoints.ipadPort - 1}px) {
    margin: 10px 0 30px;
  }

  .toggle {
    background-color: ${colors.lightBlue};
    text-align: left;
    color: ${colors.blue};
    font-weight: bold;
    text-transform: uppercase;
    padding: 15px;
    position: relative;
    cursor: pointer;

    &.open {
      span {
        + span {
          transform: translateY(-50%) rotate(0deg)
        }
      }
    }

    span {
      height: 1px;
      width: 12px;
      background-color: ${colors.blue};
      display: block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 15px;
      transition-duration: ${misc.animSpeed};

      + span {
        transform: translateY(-50%) rotate(90deg)
      }
    }
  }

  .columns {
    display: flex;
    justify-content: space-between;
    text-align: left;
    padding: 30px 0;

    > * {
      width: 100%;
      padding: 0 10px;
      line-height: 1.3;
      font-size: 14px;

      + * {
        border-left: 1px solid ${colors.middleGray};
      }
    }
  }
`;
